import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { IoLocation } from "react-icons/io5";
import Handler from "../../Helpers/Handler";
import { textCapitalize } from "../../Helpers/Utils";
import { DetailCard } from "../../Components/Needed";

// Per-person switch for location sharing. Off means the staff app stops sending this
// person's position and their latest position is removed from the live map.
const StaffLocationCard = ({ staff, onChanged }) => {
    const enabled = staff?.locationTracking !== false;
    const [confirming, setConfirming] = useState(false);
    const [saving, setSaving] = useState(false);

    const change = async (next) => {
        setSaving(true);
        const response = await Handler({ method: "patch", url: `/admin/location/tracking/${staff.staffId}`, data: { enabled: next } });
        setSaving(false);
        if (response?.success) {
            toast.success(response?.data?.message || "Updated");
            setConfirming(false);
            onChanged?.(next);
        } else {
            toast.error(textCapitalize(response?.data?.message || "Could not change location sharing"));
        }
    };

    return (
        <DetailCard title="Location sharing" icon={<IoLocation />}>
            <p className="mb-2">
                Sharing is <span className={`custom-badge ${enabled ? "badge-active" : "badge-inactive"}`}>{enabled ? "On" : "Off"}</span>
            </p>
            <p className="text-muted small">
                {enabled
                    ? "While this person is checked in, the staff app shares their location every 10 to 30 seconds. Positions are kept for 30 days."
                    : "The staff app does not share this person's location, and they do not appear on the live map."}
            </p>
            <div className="d-flex flex-wrap align-items-center gap-2">
                {enabled && !confirming ? <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => setConfirming(true)}>Turn off</button> : null}
                {enabled && confirming ? (
                    <>
                        <span className="small">Stop sharing and remove them from the live map?</span>
                        <button type="button" className="btn btn-danger btn-sm" disabled={saving} onClick={() => change(false)}>Yes, turn off</button>
                        <button type="button" className="btn btn-outline-secondary btn-sm" disabled={saving} onClick={() => setConfirming(false)}>Cancel</button>
                    </>
                ) : null}
                {!enabled ? <button type="button" className="btn btn-success btn-sm" disabled={saving} onClick={() => change(true)}>Turn on</button> : null}
                <Link to={`/staff-tracking/route/${staff.staffId}`} className="btn btn-outline-primary btn-sm">Route history</Link>
                <Link to="/staff-tracking" className="btn btn-outline-primary btn-sm">Live map</Link>
            </div>
        </DetailCard>
    );
};

export default StaffLocationCard;
